<script setup>
    import { createTextVNode, defineComponent } from 'vue';
    import { useDialog, useLoadingBar, useMessage, useNotification } from 'naive-ui';

    const ContextHolder = defineComponent({
        name: 'ContextHolder',
        setup() {
            function register() {
                if (typeof window !== 'undefined') { 
                    window.$loadingBar = useLoadingBar();
                    window.$dialog = useDialog();
                    window.$message = useMessage();
                    window.$notification = useNotification();
                }
            }

            register();

            return () => createTextVNode(); 
        }
    });
</script>

<template>
    <NLoadingBarProvider>
        <NDialogProvider>
            <NNotificationProvider>
                <NMessageProvider>
                    <ContextHolder />
                    <slot></slot>
                </NMessageProvider>
            </NNotificationProvider>
        </NDialogProvider>
    </NLoadingBarProvider>
</template>

<style scoped></style>
